import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['No sé qué publicar sin sonar repetitivo.', 'Me da pena vender.', 'Siento que necesito más seguidores para ganar.', 'Tengo días que publico y días que desaparezco.', 'Me siento ocupado… pero no avanzo.'];
  return <Section className="bg-[#0a0a0a]" data-id="element-257">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-258">
        <div data-id="element-259">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white leading-tight" data-id="element-260">
            Si te identificas con cualquiera de estas…
          </h2>
          <ul className="space-y-5" data-id="element-261">
            {pains.map((pain, index) => <li key={index} className="flex items-start gap-3 text-gray-300 text-lg" data-id="element-262">
                <XCircle className="text-red-400/80 mt-1 shrink-0" size={20} data-id="element-263" />
                <span data-id="element-264">{pain}</span>
              </li>)}
          </ul>
        </div>
        <div className="luxury-border p-8 md:p-10 relative" data-id="element-265">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#14b8a6] opacity-[0.06] rounded-full blur-2xl" data-id="element-266" />
          <p className="text-2xl font-medium text-white mb-4" data-id="element-267">
            …entonces este ebook no te va a motivar.
          </p>
          <p className="text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#14b8a6] to-[#2dd4bf] mb-6" data-id="element-268">
            Te va a ordenar.
          </p>
          <div className="luxury-divider my-6" data-id="element-269" />
          <p className="text-gray-400 leading-relaxed" data-id="element-270">
            Porque la mayoría está intentando monetizar redes sociales como si
            fuera un concurso de popularidad. Y no lo es.
            <br data-id="element-271" />
            <br data-id="element-272" />
            <span className="text-white font-bold" data-id="element-273">
              Es un sistema de conversión.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}